import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import FinancialDiagnosisForm from '../../components/diagnosis/FinancialDiagnosisForm';
import { useAuth } from '../../hooks/useAuth';
import { getLatestReportByEmail } from '../../services/diagnosisReports.service';

const FinancialDiagnosisPage = () => {
    const { user, loading: authLoading } = useAuth();
    const navigate = useNavigate();
    const [checkingReport, setCheckingReport] = useState(true);

    useEffect(() => {
        const checkExistingReport = async () => {
            if (authLoading) return;

            // If there is pending diagnosis data, we are in the middle of a guest submission flow
            // and have just returned from login/registration. Bypass redirect to existing reports.
            const pendingData = localStorage.getItem('pendingDiagnosisData');
            if (pendingData) {
                setCheckingReport(false);
                return;
            }

            if (user?.email || user?.id || user?.uid) {
                try {
                    const latestReport = await getLatestReportByEmail(
                        user.email, 
                        user.id || user.uid
                    );
                    if (latestReport) {
                        if (latestReport.status === 'completed') {
                            navigate(`/diagnosis-report/${latestReport.id || latestReport.reportId}`, { replace: true });
                            return;
                        } else {
                            // If incomplete, load it into the form so they can complete it
                            localStorage.setItem('pendingDiagnosisData', JSON.stringify(latestReport));
                            setCheckingReport(false);
                            return;
                        }
                    }
                } catch (error) {
                    console.error('Error checking existing report:', error);
                }
            }
            setCheckingReport(false);
        };

        checkExistingReport();
    }, [user, authLoading, navigate]);

    if (authLoading || checkingReport) {
        return (
            <div className="loading-screen" style={{ minHeight: '60vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <div className="spinner"></div>
            </div>
        );
    }

    return <FinancialDiagnosisForm />;
};

export default FinancialDiagnosisPage;
